<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-indent:0em">I would like to acknowledge Fay Jeffery, my mother, who has instilled the qualities of perseverance, determination, and strength in me.</p><br/>
<p style="text-indent:0em">I would also like to acknowledge my daughter Jody Hosang for her assistance with providing technological support; and Rolando Wilson, my dear friend, for his listening ear during the writing process.</p><br/>
<p style="text-indent:0em">To my eldest daughter, Sue-Jen Osei, I wish you strength and perseverance as you try to overcome your first major hurdle in this game of life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?2a0f95d8